import React from 'react'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { ErrorPageContent } from '@/components/ErrorPage'

export const ErrorOnFetchIssueState: React.FC = () => {
  const handleRetry = () => {
    window.location.reload()
  }

  return <ErrorPageContent />
}
